// extracted by mini-css-extract-plugin
module.exports = {"pairing":"Pairing_pairing__3y-_K"};